import { Skeleton, SkeletonCircle, Stack } from "@chakra-ui/react";

function StoriesSkeleton() {
  return (
    <Stack spacing={"30px"} direction={"row"} alignItems="center">
      {["", "", "", "", ""].map((data) => (
        <Stack>
          <SkeletonCircle
            w="60px"
            h="60px"
            maxW="60px"
            maxH={"60px"}
            borderRadius={"20px"}
          />
          <Skeleton height="5px" width="40px" />
        </Stack>
      ))}
    </Stack>
  );
}

export default StoriesSkeleton;
